import { validateTidalLicense } from "../../base/index.js";
import { slugify } from "./slugify.js";
import { unCamelCase } from "./unCamelCase.js";
function underscore(source) {
  return slugify(unCamelCase(source), "_");
}
validateTidalLicense();
export {
  underscore
};
//# sourceMappingURL=underscore.js.map
